'use client';

import PlausibleProvider from 'next-plausible';
import type { ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

export function Plausible({ children }: Props) {
    return (
        <PlausibleProvider
            domain="prezly.com"
            trackOutboundLinks={true}
            enabled={Boolean(process.env.NEXT_PUBLIC_ANALYTICS_ENABLED)}
            trackLocalhost={Boolean(process.env.NEXT_PUBLIC_ANALYTICS_ENABLED)}
        >
            {children}
        </PlausibleProvider>
    );
}
